import { campaignBaseModel } from './crud';

export * from './types';

export const useCampaignsByIdV2 = campaignBaseModel.fetchByIdV2();
export const useCampaignsByIdsV2 = campaignBaseModel.fetchByIdsV2();
export const useCampaignsManyV2 = campaignBaseModel.fetchManyV2();
export const useCampaignsUpdateOneV2 = campaignBaseModel.editV2();
export const useCampaignsCreateOneV2 = campaignBaseModel.createV2();
export const useCampaignsManyByContentRangeV2 =
  campaignBaseModel.fetchManyByContentRangeV2();
